import { render, staticRenderFns } from "./MetadataPopup.vue?vue&type=template&id=47670f06"
import script from "./MetadataPopup.vue?vue&type=script&lang=js"
export * from "./MetadataPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports